import React, { useState } from 'react';
import StatusBadge from '../shared/StatusBadge';
import CnamModal from './CnamModal';
import './VoiceComplianceCards.css';

const CnamCard = ({ userId, cnamData, onUpdate, disabled = false }) => {
  const [showModal, setShowModal] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const hasCnam = cnamData && cnamData.id;
  const isApproved = cnamData?.status === 'twilio-approved' || cnamData?.status === 'approved';

  const getStatusBadge = (status) => {
    if (!status) return { badge: 'draft', label: 'Draft' };

    const normalizedStatus = status.toLowerCase().trim();
    console.log('CNAM Status Debug - Raw:', status, 'Normalized:', normalizedStatus);

    const statusMap = {
      'draft': { badge: 'draft', label: 'Draft' },
      'pending-review': { badge: 'pending', label: 'Pending Review' },
      'in-review': { badge: 'pending', label: 'Pending Review' },
      'pending': { badge: 'pending', label: 'Pending Review' },
      'twilio-approved': { badge: 'approved', label: 'Approved' },
      'twillio-approved': { badge: 'approved', label: 'Approved' }, // typo version
      'approved': { badge: 'approved', label: 'Approved' },
      'twilio-rejected': { badge: 'rejected', label: 'Rejected' },
      'rejected': { badge: 'rejected', label: 'Rejected' },
    };

    const result = statusMap[normalizedStatus] || { badge: 'draft', label: status };
    console.log('CNAM Status Debug - Result:', result);
    return result;
  };

  const getHeaderColorClass = (status) => {
    const normalizedStatus = status ? status.toLowerCase() : '';
    if (['twilio-approved', 'approved'].includes(normalizedStatus)) return 'card-header--approved';
    if (['pending-review'].includes(normalizedStatus)) return 'card-header--pending';
    if (['twilio-rejected', 'rejected'].includes(normalizedStatus)) return 'card-header--rejected';
    if (['draft'].includes(normalizedStatus)) return 'card-header--draft';
    return 'card-header--default';
  };

  const getButtonText = () => {
    if (!hasCnam) return 'Add Caller ID Name (CNAM)';
    if (isApproved) return 'View';
    return 'Edit CNAM';
  };

  const handleModalClose = async (updated) => {
    setShowModal(false);
    if (updated) {
      setIsRefreshing(true);
      await onUpdate();
      setTimeout(() => {
        setIsRefreshing(false);
      }, 1500);
    }
  };

  return (
    <>
      <div className={`voice-compliance-card ${disabled ? 'voice-compliance-card--disabled' : ''}`} id="VoiceIntegrityCard">
        {/* Header with Icon and Title */}
        <div className={`card-header ${hasCnam ? getHeaderColorClass(cnamData.status) : ''}`}>
          <div className="card-icon-title">
            <i className="la la-id-card" style={{ fontSize: '20px' }}></i>
            <h3 className="card-title">CNAM (Caller ID Name)</h3>
          </div>
          {hasCnam && (
            <StatusBadge status={getStatusBadge(cnamData.status).badge} label={getStatusBadge(cnamData.status).label} />
          )}
        </div>

        {/* Current Name Info */}
        {hasCnam && (
          <div className="card-info">
            <div className="info-row">
              <span className="info-label" style={{marginLeft: '-7px'}}>Caller ID Name (CNAM): {cnamData.friendly_name || 'Not set'}</span>
              <i className="la la-pen" onClick={() => !disabled && setShowModal(true)} style={{ cursor: disabled ? 'not-allowed' : 'pointer', color: disabled ? '#ccc' : '#087ab6', marginLeft: '8px' }}></i>
            </div>
          </div>
        )}

        {/* Status Messages */}
        {disabled ? (
          <div className="status-message status-message-warning">
            <p>Complete Business Profile and SHAKEN/STIR Attestation first to enable CNAM</p>
          </div>
        ) : hasCnam ? (
          <>
            {(cnamData.status === 'twilio-approved' || cnamData.status === 'approved') && (
              <div className="status-message status-message-success">
                <p>CNAM registration is approved and active</p>
              </div>
            )}

            {cnamData.status === 'pending-review' && (
              <div className="status-message status-message-warning">
                <p>Pending review (typically 3-5 business days)</p>
              </div>
            )}

            {(cnamData.status === 'twilio-rejected' || cnamData.status === 'rejected') && (
              <div className="status-message status-message-error">
                <p>Registration rejected. Please update and resubmit.</p>
              </div>
            )}

            {cnamData.status === 'draft' && (
              <div className="status-message status-message-warning">
                {/* <p>Draft saved. Complete and submit for review.</p> */}
              </div>
            )}
          </>
        ) : null}

        {/* Button in Body - Hide when approved */}
        {!isApproved && (
          <button
            className="btn linear-gradient zy-save-btn edit-ename-btn"
            onClick={() => setShowModal(true)}
            disabled={disabled}
            style={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? 'not-allowed' : 'pointer', marginTop: '15px' }}
          >
            {getButtonText()}
          </button>
        )}

        {/* Refreshing Overlay */}
        {isRefreshing && (
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 100,
            borderRadius: '12px'
          }}>
            <div style={{ textAlign: 'center' }}>
              <div className="ui active inline loader" style={{ marginBottom: '10px' }}></div>
              <p style={{ color: '#087ab6', fontSize: '13px', fontWeight: 500, margin: 0 }}>
                Refreshing data...
              </p>
            </div>
          </div>
        )}
      </div>

      {/* CNAM Modal */}
      {showModal && (
        <CnamModal
          userId={userId}
          cnamData={cnamData}
          isEditMode={hasCnam}
          isApproved={isApproved}
          onClose={handleModalClose}
        />
      )}
    </>
  );
};

export default CnamCard;
